<div class="sync-dialog-content mt-1">
    <form
        [formGroup]="syncFormGroup"
        #syncForm="ngForm"
        id="syncForm"
        class="flexForm"
    >
        <p-message
            severity="info"
            text="The History Filter date range controls the periods available for the From and To selections."
        ></p-message>
        <div class="radio-container mb-1 mt-1">
            <div
                class="flex items-center radio-item"
                [class.radio-item-active]="isSyncType('Quickbooks')"
                role="button"
                tabindex="0"
                (click)="setSyncType('Quickbooks')"
                (keydown.enter)="setSyncType('Quickbooks')"
                (keydown.space)="setSyncType('Quickbooks')"
            >
                <p-radioButton
                    name="syncType"
                    value="Quickbooks"
                    #SyncType
                    formControlName="syncType"
                ></p-radioButton>
                <label class="ml-2">Sync with Current Rates</label>
            </div>
            <div
                class="flex items-center radio-item"
                [class.radio-item-active]="isSyncType('Session')"
                role="button"
                tabindex="0"
                (click)="setSyncType('Session')"
                (keydown.enter)="setSyncType('Session')"
                (keydown.space)="setSyncType('Session')"
            >
                <p-radioButton
                    name="syncType"
                    value="Session"
                    #SyncType
                    formControlName="syncType"
                ></p-radioButton>
                <label class="ml-2">Sync to Period</label>
            </div>
        </div>
        <!-- FromPeriod -->
        <div [hidden]="syncFormGroup.controls['syncType'].value === 'Quickbooks'">
            <p-floatLabel variant="on">
                <p-select
                    #fromPeriod
                    [style]="{ 'min-width': '11em', width: '100%' }"
                    [virtualScroll]="true"
                    [itemSize]="dropdownItemHeight"
                    [options]="FromPeriodSelectItems"
                    [autoDisplayFirst]="false"
                    formControlName="FromPeriod"
                    appendTo="body"
                    defaultLabel="Name"
                    [filter]="true"
                ></p-select>
                <label for="float-dd">From Period</label>
            </p-floatLabel>
        </div>
        <!-- ToPeriod -->
        <div>
            <p-floatLabel variant="on">
                <p-select
                    #toPeriod
                    [style]="{ 'min-width': '11em', width: '100%' }"
                    [virtualScroll]="true"
                    [itemSize]="dropdownItemHeight"
                    [options]="ToPeriodSelectItems"
                    [autoDisplayFirst]="false"
                    formControlName="ToPeriod"
                    appendTo="body"
                    defaultLabel="Name"
                    [filter]="true"
                    [disabled]="
                        syncFormGroup.controls['syncType'].value === 'Session' &&
                        !fromPeriod.value
                    "
                ></p-select>
                <label for="float-dd">To Period</label>
            </p-floatLabel>
        </div>
    </form>
    <div class="button-bar">
        <button
            type="button"
            #ok
            pButton
            aria-label="Sync"
            label="Sync"
            class="p-button-primary"
            icon="pi pi-sync"
            [disabled]="syncForm.invalid"
            (click)="onOk.next(syncFormGroup.value)"
        ></button>
        <button
            type="button"
            #cancel
            pButton
            aria-label="Cancel"
            label="Cancel"
            class="p-button-danger"
            (click)="onCancel.next()"
        ></button>
    </div>
</div>
